module.exports = __webpack_public_path__ + "media/images/illustrations/plan_size_small-567460ab8838c874caa86e477bbd8246.svg";